import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './resources';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('petf-language') || undefined,
    fallbackLng: 'en',
    debug: false,
    supportedLngs: ['ja', 'en'],
    resources,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'petf-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
